module.exports = __webpack_public_path__ + "static/img/39.4545ea08.png";